// Fabric by the Yard hub: designer rail dots and prev/next, dead jump links, Marqo pagination
// (keeping ?view=, scrolling to the grid) and the app's hidden H1.
// Loaded by snippets/fby-interactions.liquid from the hero, the designer rail and the product grid.
(() => {
  // Each hub section adds a tag for this file, so it can run more than once; later runs only bind
  // anything that has rendered since.
  if (window.msqcFbyHub) {
    window.msqcFbyHub.bindAll();
    return;
  }
  function bindRails() {
    document.querySelectorAll('[data-fby-rail]').forEach((rail) => {
      if (rail.dataset.fbyBound) return;
      rail.dataset.fbyBound = 'true';
      const dots = document.querySelector(`[data-fby-dots="${rail.id}"]`);
      if (!dots) return;
      const update = () => {
        let active = 0;
        const first = rail.children[0];
        if (first) {
          const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
          active = Math.round(rail.scrollLeft / (first.getBoundingClientRect().width + gap));
        }
        // a rail stops scrolling before its last items reach the start, so treat the end as the last dot
        // (only once it has scrolled: a rail that doesn't overflow yet is also "at the end")
        const maxScroll = rail.scrollWidth - rail.clientWidth;
        if (maxScroll > 2 && rail.scrollLeft > 0 && rail.scrollLeft >= maxScroll - 2) active = dots.children.length - 1;
        active = Math.min(active, dots.children.length - 1);
        [...dots.children].forEach((dot, index) => {
          dot.setAttribute('aria-current', index === active ? 'true' : 'false');
        });
      };
      rail.addEventListener('scroll', update, { passive: true });
      // overflow changes as images load and when the viewport resizes
      if (window.ResizeObserver) new ResizeObserver(update).observe(rail);
      update();
    });
  }
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-fby-scroll], [data-fby-slide]');
    if (!button) return;
    const rail = document.getElementById(button.getAttribute('aria-controls'));
    if (!rail) return;
    const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
    if (button.hasAttribute('data-fby-slide')) {
      const child = rail.children[Number(button.dataset.fbySlide)];
      if (child)
        rail.scrollTo({
          left: child.offsetLeft - rail.children[0].offsetLeft,
          behavior,
        });
    } else {
      rail.scrollBy({
        left: rail.clientWidth * Number(button.dataset.fbyScroll),
        behavior,
      });
    }
  });
  // Marqo pages its results in place and then scrolls the window to the top (window.scrollTo({ top: 0 })),
  // sometimes more than once per page change, with no setting to turn that off. From a pagination click
  // until just after the new results arrive, send those scrolls to the top of the product grid instead,
  // so the page moves once rather than up and back down.
  const nativeScrollTo = window.scrollTo.bind(window);
  let redirectUntil = 0;
  document.addEventListener(
    'click',
    (event) => {
      if (event.target.closest('.fby-products nav[aria-label="Pagination"]')) redirectUntil = Date.now() + 5000;
    },
    true
  );
  document.addEventListener('marqo:search.results', () => {
    if (Date.now() < redirectUntil) redirectUntil = Date.now() + 1000;
  });
  window.scrollTo = function (options, y) {
    const grid = document.querySelector('.fby-products');
    const toTop = options && typeof options === 'object' ? options.top === 0 : options === 0 && y === 0;
    if (grid && toTop && Date.now() < redirectUntil) {
      const top = grid.getBoundingClientRect().top + window.scrollY;
      return nativeScrollTo({ ...(typeof options === 'object' ? options : {}), top });
    }
    return nativeScrollTo(...arguments);
  };
  function bindPagination() {
    const grid = document.querySelector('.fby-products');
    if (!grid || grid.dataset.fbyBound) return;
    grid.dataset.fbyBound = 'true';
    const retainState = () => {
      // The app can recreate its hidden H1 after rendering; retain one page H1.
      const heading = grid.querySelector('h1.marqo-page-heading');
      if (heading) {
        const replacement = document.createElement('h2');
        for (const attribute of heading.attributes) replacement.setAttribute(attribute.name, attribute.value);
        replacement.replaceChildren(...heading.childNodes);
        heading.replaceWith(replacement);
      }
      const current = new URL(location.href);
      if (!current.searchParams.has('view')) return;
      grid.querySelectorAll('nav[aria-label="Pagination"] a[href]').forEach((link) => {
        const destination = new URL(link.href, location.href);
        if (destination.origin !== current.origin || destination.pathname !== current.pathname) return;
        const next = new URL(current.href);
        next.hash = '';
        const page = destination.searchParams.get('page');
        if (page) next.searchParams.set('page', page);
        else next.searchParams.delete('page');
        if (link.href !== next.href) link.href = next.href;
      });
    };
    retainState();
    // the app re-renders often (images, ratings, filters); run once per frame rather than per mutation
    let queued = false;
    const queueRetainState = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        retainState();
      });
    };
    new MutationObserver(queueRetainState).observe(grid, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['href'],
    });
  }
  // The hero's jump links point at other hub sections; hide any whose section is disabled or removed.
  function hideDeadJumps() {
    document.querySelectorAll('[data-fby-jump]').forEach((link) => {
      link.hidden = !document.getElementById(link.getAttribute('href').slice(1));
    });
  }
  function bindAll() {
    hideDeadJumps();
    bindRails();
    bindPagination();
  }
  window.msqcFbyHub = { bindAll };
  bindAll();
  document.addEventListener('DOMContentLoaded', bindAll);
  document.addEventListener('shopify:section:load', bindAll);
  // a section is still in the page while its unload event runs
  document.addEventListener('shopify:section:unload', () => setTimeout(hideDeadJumps));
})();
